/* eslint-disable */
import React from 'react'
import {Icon} from 'antd'

class EditDriver extends React.Component {
  render() {
    return (
      <div className="rtl">
        {/*<OperatorMenu/>*/}
        <div className="container">
          <form className="EnterForm">
            <div className="bannerForm">
              <p>رساننده یا خودروی مورد نظر را تغییر دهید.</p>
            </div>
            <div className="formComponent">
              <div className="dateInputWrap">
                <span>
                  <Icon type="user" theme="outlined" />
                </span>
                <select>
                  <option value="">لطفا نام رساننده را انتخاب کنید</option>
                  <option>عرفان عربان</option>
                </select>
              </div>
              <div className="dateInputWrap">
                <span>
                  <Icon type="car" theme="outlined" />
                </span>
                <select>
                  <option value="">لطفا نوع خودرو را انتخاب کنید</option>
                  <option>وانت پراید</option>
                  <option>مزدا 1000</option>
                  <option>مزدا 2000</option>
                  <option>وانت پیکان</option>
                  <option>وانت آریسان</option>
                  <option>نیسان آبی</option>
                </select>
              </div>
              <button>اعمال تغییرات</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default EditDriver
